<template>
    <div class='wrap'>
        <div class='head'>
            <!-- <p class="headOne">INTERNET HOSPITAL SYSTEM</p>
            <p class="headTwo">互联网医院系统</p>
            <p class='headThree'>数据信息统一化+<br>丰富医疗服务内容+拓展医疗资源辐射范围</p>
            <img class='videoStart' src='./../../../assets/Mobile/solution/solutionImg.png'> -->
            <p class="headOne">
                SMART AND SECURE MEDICAL SOLUTION<br/>
                GATEWAY TO INTELLIGENT HEALTH CARE
            </p>
            <p class="headTwo">专业安全的医疗解决方案</p>
            <p class='headTwo'>开启智慧医疗</p>
            <img class='videoStart' src='./../../../assets/Pc/banner3.png'>
        </div>
        <div class='titleBox'>
            系统性解决方案
            <img class='down' src="./../../../assets/Mobile/Boao/downL.gif" alt="">
        </div>

        <img class='centerImg' src="./../../../assets/Pc/solute1.png" alt="">
        <p class='onLineTitle'>
            5G环境部署
        </p>
        <div class='context'>
中卫佰医与中国移动集团公司政企分公司在远程医疗系统建设领域达成战略合作，双方在服务器资源、5G基础设施、云视讯技术、软件平台、硬件设备等方面全面协同，共同为医院提供集资源对接、平台建设、医联体运营为一体的远程医疗整体解决方案
        </div>
        <img class='centerImg' src="./../../../assets/Pc/solute2.png" alt="">
        <p class='onLineTitle'>
            系统建设
        </p>
        <div class='context'>
             中卫佰医自主研发了便捷高效的远程医疗系统，实现了医院与医院、医院与医生、医生与医生之间的无缝连接，各医疗机构和各级医生上下联通，实际运行中效果良好。同时，中卫佰医与华西医院下属的华西公用医疗信息服务有限公司在互联网医院建设领域达成战略合作。
        </div>
        <img class='centerImg' src="./../../../assets/Pc/solute3.png" alt="">
        <p class='onLineTitle'>
            医疗资源
        </p>
        <div class='context'>
            中卫佰医通过远程医疗系统构建医生协作网络，上下联通国家级大型三甲医院、省级三甲医院、地市级三甲医院、县级医院、乡镇医院、村诊所、社区服务中心、私人诊 所，既有助于上级医院及医生获得优质病源、进一步提高研发水平，又有助于下级医院及医生获得精心指导，进一步提高诊疗水平，促进整体提高诊疗服务能力。
        </div>
        <img class='centerImg' src="./../../../assets/Pc/solute4.png" alt="">
        <p class='onLineTitle'>
            专业运营
        </p>
        <div class='context'>
            中卫佰医目前在运营的省级、地市级医联体数量超过20家，月远程会诊数量超过5000例，目前以地市级核心医院组建的医联体的月远程会诊数量超过2000例，获得了相关省市领导、媒体的高度关注。
        </div>
        <img class='centerImg' src="./../../../assets/Pc/solute5.png" alt="">
        <p class='onLineTitle'>
            金融支持
        </p>
        <div class='context'>
             中卫佰医在远程医疗系统和互联网医院系统的建设和运营中，均以达成促进医院发展为目标，根据医院需求，医院可以选择不进行资金投入，中卫佰医针对远程医疗系统、互联网医院系统进行建设投入，根据医院的场景及环境需求，定制符合医院要求的解决方案，并快速完成落地实施。平台建成后，中卫佰医负责运营，通过运营合作收回投资。
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {

            }
        }
    }
</script>
<style lang="less" scoped>
.head {
    width: 100%;
    height: 413px;
    background: url('./../../../assets/Mobile/solution/solutionHead.png') no-repeat;
    background-size: 100% 100%;
    background-color:linear-gradient(128deg,rgba(59,167,234,1),rgba(59,78,222,1),rgba(59,78,222,1));
    font-family:NotoSansHans-Medium;
    font-weight:500;
    color:rgba(255,255,255,1);
    text-align: left;
    padding-top: 77px;
    margin-bottom:20px;
    position: relative;
    .headOne{
        margin-bottom:20px;
        font-size:18px;
        font-family:PangMenZhengDao;
        font-weight:400;
        color:#CECECE;
        padding-left: 20px;
        line-height:36px;
        transform: scale(0.9) translateX(-38px);
        text-align: left
    }
    
    .headTwo{
        font-size:28px;
        padding-left: 20px;
        font-family:NotoSansHans-Bold;
        font-weight:bold;
        color:rgba(255,255,255,1);
        line-height:50px;
        margin-bottom: 10px;
    }
    .headThree{
        padding-left: 20px;
        font-family:NotoSansHans-Bold;
        font-weight:bold;
        color:rgba(255,255,255,1);
        line-height:48px;
        font-size:22px;
    }
    .videoStart{
        position: absolute; right: 30px; top: 7px;
        width:484px;
    }
}
// 标题
.titleBox{
    font-size:28px;
    font-family:NotoSansHans-Medium;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:36px; 
    text-align:center;
    // margin-bottom:34px;
    .down{
        width: 43px; display: block; margin:23px auto 60px; 
    }
}
.titleBoxTwo{
    text-align:center;
    margin-bottom:70px;
    .titleOne{
        font-size:24px;
        font-family:PangMenZhengDao;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:30px;
        background:linear-gradient(176deg,rgba(61,170,246,1) 7.5439453125%, rgba(174,195,255,1) 99.5849609375%);
        -webkit-background-clip:text;
        -webkit-text-fill-color:transparent;
    }
    .titleTwo{
        font-size:24px;
        font-family:NotoSansHans-Bold;
        font-weight:bold;
        color:rgba(51,51,51,1);
        line-height:30px;
    }
}
// 图片
.centerImg{
    width: 394px; margin: 0 auto; display: block; margin-bottom:57px;
}
.onLineTitle{
    font-size:24px;
    font-family:MicrosoftYaHei;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:32px;
    text-align:center; margin-bottom: 52px;
}
.context{
    width:628px;
    font-size:24px;
    font-family:PingFangSC-Light;
    font-weight:300;
    color:rgba(51,51,51,1);
    line-height:36px;
    margin: 0 auto 54px;
}
</style>